import { Component, OnInit } from '@angular/core';
import { UserService } from '../../services/user.service';
import { environment } from '../../../environments/environment';
@Component({
  selector: 'app-employee',
  templateUrl: './employee.component.html',
  styleUrls: ['./employee.component.less']
})
export class EmployeeComponent implements OnInit {
  isCollapsed = false;
  loading = false;
  employees:any=[];
  employeeName:any=[];
  employeesTotal:number;
  getFullYear: number = new Date().getFullYear();
  getMonth: number = new Date().getMonth() + 1;
  getDate: number = new Date().getDate();
  imgBaseURL =  environment.apiUrl + '/static/';
  perPage = -1;
  page = 1;
  total:number;
  current = 1;
  department:any=[];
  searchDepartment:string = "";
  searchGender:string = "";
  searchEmployees:string = "";

  nzFilterOption = (): boolean => true;
  queryParams = [
    "work_status=0"
  ]
  constructor(
    private userService:UserService,
  ) { }
  

  ngOnInit() {
    this.getDepartment();
    this.getEmployee();    
  }


  getEmployee(){
    this.loading = true;

    this.queryParams = [
      "work_status=0",
      (this.searchEmployees)? 'name='+this.searchEmployees : '',
      (this.searchDepartment)? 'dept='+this.searchDepartment : '',
      (this.searchGender)? 'sex='+this.searchGender : '',
    ]
    const filteredArr = this.queryParams.filter((e) => { return e != ""; }).join('&');

    this.userService.getEmployee(this.perPage, this.page, filteredArr).subscribe((res:any)=>{
      this.employees = res.data.data;
      this.employeesTotal = res.data.total;
      this.loading = false;
      console.log("this.employees", this.employees)
    });
  }

  onPageIndexChange($event) {
    this.page = $event;
    this.getEmployee();    
  }

  handleFillter() {

  }

  searchDepartmentId(event: any){
    this.searchDepartment = event;
    this.getEmployee()
  }

  searchGenderValue(event: any){
    this.searchGender = event;
    this.getEmployee()
  }
  
  searchEmployeesName(event:any){
    console.log('event', event);
    this.searchEmployees = event.target.value;

    this.getEmployee();
  }

  getDepartment(){
    this.userService.getAllDepartment().subscribe((res)=>{
      this.department = res.data.data;
      console.log(this.department);
    })
  }
}
